const VueAxios = {
  vm: {},
  //eslint-disable-next-lineno-unused-vars
  install(Vue, instance) {
    if (this.installed) {
      return
    }
    this.installed = true

    if (!instance) {
      //eslint-disable-next-lineno-console
      console.error('Youhavetoinstallaxios')
      return
    }

    Vue.axios = instance

    Object.defineProperties(Vue.prototype, {
      axios: {
        get: function get() {
          return instance
        },
      },
      $http: {
        get: function get() {
          return instance
        },
      },
    })
  },
}

export { VueAxios }
